// Shared In-Stock grid + fallback — used by the homepage section and /in-stock.
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { API_BASE } from '../../lib/apiBase';

export function useInStock(limit = 0) {
        const [state, setState] = useState({ loading: true, count: 0, products: [] });
        useEffect(() => {
                let alive = true;
                fetch(`${API_BASE}/api/in-stock${limit ? `?limit=${limit}` : ''}`)
                        .then((r) => r.json())
                        .then((j) => { if (alive) setState({ loading: false, count: j.count || 0, products: j.products || [] }); })
                        .catch(() => { if (alive) setState({ loading: false, count: 0, products: [] }); });
                return () => { alive = false; };
        }, [limit]);
        return state;
}

export function InStockCard({ p }) {
        return (
                <Link to={`/p/${p.handle}`} data-testid="in-stock-card" className="group block border border-white/10 bg-[#0A0A0A] hover:border-[#FF9F1C] transition-colors">
                        <div className="relative aspect-square bg-[#111] overflow-hidden">
                                {p.image && <img src={p.image} alt={p.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-[1.03] transition-transform duration-300" />}
                                <span className="absolute top-3 left-3 flex items-center gap-1.5 bg-[#0A0A0A]/85 border border-emerald-500/50 px-2 py-1 font-mono text-[10px] tracking-[0.16em] uppercase text-emerald-300">
                                        <span className="h-1.5 w-1.5 rounded-full bg-emerald-400" /> In stock
                                </span>
                        </div>
                        <div className="p-4">
                                <p className="font-display text-[15px] text-white uppercase leading-tight line-clamp-2">{p.title}</p>
                                {p.price && <p className="mt-2 font-mono text-[13px] text-white/80">₹{Number(p.price).toLocaleString('en-IN', { maximumFractionDigits: 0 })}</p>}
                        </div>
                </Link>
        );
}

export function InStockFallback() {
        return (
                <div data-testid="in-stock-fallback" className="border border-dashed border-white/20 p-8 md:p-10">
                        <p className="font-display text-[24px] md:text-[28px] uppercase leading-tight">Ready-to-ship shelf is restocking.</p>
                        <p className="mt-3 font-sans text-[14px] text-white/60 max-w-[560px]">Nothing is sitting on the shelf right now — fresh stock lands often. Meanwhile, check the newest arrivals or read up in the Lab.</p>
                        <div className="mt-6 flex flex-wrap gap-3">
                                <Link to="/drops" data-testid="in-stock-fallback-drops" className="font-mono text-[11px] tracking-[0.2em] uppercase bg-[#FF9F1C] text-[#0A0A0A] px-5 py-3 hover:bg-white transition-colors">See Drops →</Link>
                                <Link to="/operator-lab" data-testid="in-stock-fallback-lab" className="font-mono text-[11px] tracking-[0.2em] uppercase border border-white/30 px-5 py-3 hover:border-[#FF9F1C] hover:text-[#FF9F1C] transition-colors">Open The Lab →</Link>
                        </div>
                </div>
        );
}
